import NewButton from '$tablet-app/src/app/components/Button/NewButton';
import Dialog from '$tablet-app/src/app/components/Dialog';
import { DialogProps } from '$tablet-app/src/app/components/Dialog/Dialog';
import DialogBody from '$tablet-app/src/app/components/Dialog/DialogBody';
import DialogBottomActions from '$tablet-app/src/app/components/Dialog/DialogBottomActions';
import DialogHeader from '$tablet-app/src/app/components/Dialog/DialogHeader';
import Row from '$tablet-app/src/app/components/Row';
import Spacer from '$tablet-app/src/app/components/Spacer';
import { useStateStore } from '$tablet-app/src/app/stores/useStateStore';
import { Text } from '@akin-home/text/native';
import styled from 'styled-components/native';

interface Props extends DialogProps {
  /** The email that will be sent a temporary PIN */
  email?: null | string;

  onPressConfirm?: () => void;
}

export const ForgotPINDialog = ({
  email,
  onPressConfirm,
  ...dialog_props
}: Props) => {
  const forgot_pin_dialog_visible = useStateStore(
    (state) => state.lock_screen.forgot_pin_dialog_visible
  );

  const closeForgotPINDialog = useStateStore(
    (state) => state.lock_screen.closeForgotPinDialog
  );

  return (
    <Dialog
      visible={!!forgot_pin_dialog_visible}
      onClose={closeForgotPINDialog}
      {...dialog_props}
    >
      <DialogHeader
        center={
          <Text variant="h3" weight="semibold">
            Forgot PIN
          </Text>
        }
      />
      <Body>
        {email ? (
          <Text>
            A temporary PIN will be sent to your email at:{' '}
            <Text weight="semibold">{email}</Text>
          </Text>
        ) : (
          <Text>
            Current user has no email to sent a temporary PIN to. Please add an
            email to this account or contact aKin for support.
          </Text>
        )}
      </Body>

      <DialogBottomActions>
        <Row>
          <NewButton variant="secondary" onPress={closeForgotPINDialog}>
            Cancel
          </NewButton>
          {email?.length ? (
            <>
              <Spacer width="16px" />
              <NewButton onPress={onPressConfirm}>Confirm</NewButton>
            </>
          ) : null}
        </Row>
      </DialogBottomActions>
    </Dialog>
  );
};

const Body = styled(DialogBody)`
  align-items: center;

  padding: 50px;
`;
